
class PreselectedPricetypeQuantities {
  /**
   * @param {PricetypeQuantities} pricetypeQuantities
   */
  constructor(pricetypeQuantities) {
    this.pricetypeQuantities = pricetypeQuantities;
  }

  getAllPricetypeQuantities() {
    return this.pricetypeQuantities;
  }

  getTotalQuantitySelected() {
    return this.pricetypeQuantities
      .reduce((sum, { quantity }) => sum + quantity, 0);
  }
}

export default PreselectedPricetypeQuantities;



// WEBPACK FOOTER //
// ./V7/events/detail/PreselectedPricetypeQuantities.js